import { TRAITS } from 'components/common/ScoreCard/ScoreCard'
import { getFactors, TAB_NAMES } from 'components/modals/TestsReportModal/model'
import {
  formatTraitAbstract,
  getRecruiterTraits,
} from './helpScoreCardText'

const TRAIT_ICONS = {
  Agreeableness: 'A',
  Conscientiousness: 'C',
  Extraversion: 'E',
  'Openness to Experience': 'O',
  'Emotional Stability': 'N',
}

const buildTraitCard = (factorKey, language) => {
  const traits = getRecruiterTraits(language)
  const { label = factorKey, abstract, high = '', low = '' } =
    traits[factorKey] || {}

  return {
    id: factorKey,
    icon: TRAIT_ICONS[factorKey] || label[0],
    title: label,
    description: formatTraitAbstract(abstract, label),
    highScore: high,
    lowScore: low,
    facets: (TRAITS[factorKey] || []).map(id => traits[id]?.label || id),
  }
}

export const getBigFiveTraits = language =>
  getFactors(true, false)
    .filter(({ parentId }) => parentId === TAB_NAMES.PERSONALITY)
    .map(({ factor }) => buildTraitCard(factor, language))

export const BIG_FIVE_SECTION_TITLE = {
  en: 'What is the Big Five?',
  nb: 'Hva er big five?',
}
